import { container, title } from "assets/jss/material-kit-react.jsx";

const heroCardStyle = {
  containerParent: {
    backgroundColor: "#e5e5e5",
    position: "relative",
    margin: "0",
    padding: "100px 0px",
    border: "0",
    display: "flex",
    alignItems: "center"
  },
  container: {
    ...container,
    zIndex: "12",
    marginLeft: "auto",
    paddingLeft: "30px",
    marginRight: "auto",
    paddingRight: "15px"
  },
  gridContainerItem: {
    width: "100%",
    zIndex: "24"
  },
  gridContainerItem2: {
    width: "100%",
    zIndex: "24",
    textAlign: "left"
  },
  inlineBlock: {
    display: "inline-block",
  },
  title: {
    fontSize: "2.25rem",
    fontWeight: "700",
    textDecoration: "none",
    textAlign: "left",
    marginTop: "30px",
    "& sup": {
      fontSize: "50%"
    }
  },
  subtitle: {
    lineHeight: "1.5em",
    marginTop: "0px",
    textAlign: "left",
    color: "#6c757d",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  text: {
    textAlign: "left",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    textAlign: "justify",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  footnote: {
    fontSize: "80%",
    fontStyle: "italic",
    color: "#6c757d",
    textAlign: "left"
  },
  feature: {
    marginBottom: "15px"
  },
  featureImage: {
    width: "70px",
    height: "70px",
    marginLeft: "-15px",
    marginTop: "-5px",
    borderRadius: "50% !important",
    boxShadow:
      "0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  featureBody: {
    paddingLeft: "0px"
  },
  featureTitle: {
    marginBottom: "0px"
  },
  featureSubtitle: {
    marginTop: "0px"
  }
}

export default heroCardStyle;